// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xb_a bha_uj bha_ua bha_vx bha_qk bha_sl bha_qb"};